import { Component, OnInit, ElementRef, OnDestroy, ChangeDetectorRef, AfterViewChecked, AfterViewInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import * as DepDetailsActions from '../../../../store/actions/dependant-details.actions';
import * as LifeStyleActions from 'src/app/pages/medical-underwriting/store/actions/lifestyle.action';
import * as UserDataConfig from '../../config/user-data.config';
import { AuthService, CurrencyFunctionalityService, DealPartnerFunctionalityService, SERVICE_END_POINT } from 'src/app/shared';
import { FormValidationsService, QuoteDataCaptureService, ProductCodeValidators } from 'src/app/shared';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
import { AppState } from '../../../../store/state/app.state';
import { YourPension, RefNo, PersonalDetails } from '../../../../model/ngrx';
import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { AlertModal } from 'src/app/model/alert';
import { UtilService } from '../../../../shared';
import { UntypedFormArray } from '@angular/forms';
import { CardRefresh } from 'src/app/model/ngrx/card-refresh.model';
import * as ProductChoiceActions from '../../../../store/actions/product-choice.actions';
import * as ReqQuoteCalcActions from '../../../../store/actions/request-quote-calculation.actions';
import * as ResQuoteCalcActions from '../../../../store/actions/response-quote-calculation.actions';

import { AnalyticsService } from '../../../../shared';
import { UIRulesService } from 'src/app/shared/services/api-services/ui-rules.service';
import { Attributes, DisplayRuleToBeApplied, ComponentTypes } from 'src/app/model/ui-rule-response-model';
import { ATTRIBUTE_NAME_ID } from '../../config/ceding-fund-attribute-id';
import { UiRuleReqPayload, AttributeReqPayLoad, ComponentAttributes } from 'src/app/model/ui-rule-request-payload';
import { AttributeIdAndStyle } from 'src/app/model/ui.attribute.style.model';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-your-ceding-fund',
  templateUrl: './your-ceding-fund.component.html',
  styleUrls: ['./your-ceding-fund.component.scss']
})
export class YourCedingFundComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {

  public contentData: any;
  protected cmsAlertData: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;
  public yourPensionForm: UntypedFormGroup;
  protected sourcesCvt: any[] = this.userInputDetail.sourcesListCvt;
  public sourcesConfiguration = [];
  protected fundAttributes = this.userInputDetail.fundAttributes;
  //protected fundProviderConfig = this.userInputDetail.fundProviderConfig;
  public fundProviderConfig: any;
  public pensionFundConfig: any;
  public funproviderinformationConfig = this.userInputDetail.dealPartnerInformation;
  protected fundValueConfig = this.userInputDetail.fundValueConfig;
  protected productCodeConfig = this.userInputDetail.productCodeConfig;
  public totalFundAmount = 0;
  public manualSourceSelection = false;
  public manualSourceConfig;
  public pensionPotErrorValidatorFlag = false;
  public displayAlert = false;
  public displayEditAlert = false;
  public validSource = false;
  public externalMinInvalid = false;
  public alertModalConfig: AlertModal;
  // tslint:disable-next-line: max-line-length
  public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');

  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  public showControl = false;
  protected cedingFundAmount = 0;
  public tooltipModalConfig: AlertModal;
  loginDetail: any;
  tooltipModal;
  public selectedProductAvailable: boolean = true;
  yourPensionStore: Observable<YourPension[]>;
  pensionForm: YourPension;
  referenceNumberStore: Observable<RefNo[]>;
  cardRefreshStore: Observable<CardRefresh[]>;
  referenceNumber: RefNo;
  editMode: boolean;
  pensionFormEdit: YourPension;
  QuoteAffectingValues: any;
  personalForm: PersonalDetails;
  personalDetailsStore: Observable<PersonalDetails[]>;
  productCodeData = [];
  benefitTypesValues = [];
  productTypesValues = [];
  showModalForCardRefresh: boolean = false;
  cardRefresh: boolean;
  cardStoreVal: boolean;
  quoteRefNo: string;
  isValidated: boolean;
  pensionPotFlag: boolean = false;
  fundProviderFlag: boolean = false;
  public minprodCodeLength = {
    value: false
  };
  // tslint:disable-next-line:max-line-length
  public alertModalEditConfig: AlertModal;
  private subscripLogout: Subscription;
  private fundProviderChangeSub: Subscription;
  public CMSData;
  private contentDataConstants;
  public sourceLength;
  screenName;
  cameFromMicrosite = false;
  lAndGWarningFlag: boolean = false;
  aonWarningFlag: boolean = false;
  slocWarningFlag: boolean = false;
  sourceAttributeObj: Attributes;
  sourceDisplayRules: DisplayRuleToBeApplied;
  annuitantCompRules: ComponentTypes;
  public configData: any;
  displayTooltipAlert = false;
  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
    private store: Store<AppState>, private quoteDatacaptureService: QuoteDataCaptureService,
    public el: ElementRef,
    private utilService: UtilService,
    private cdRef: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
    private uiRulesService: UIRulesService, private authService: AuthService
  ) {
    this.activatedRoute.data
      .subscribe((data) => {
        this.annuitantCompRules = data.uiCompJson;
        // this.configData = data.configJson;
      });
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.contentDataConstants = this.activatedRoute.snapshot.data.contentData.generalConstants;
    this.cmsAlertData = this.activatedRoute.snapshot.data.contentData;
    this.manualSourceConfig = this.contentData['manualSourceSelection'];
    this.yourPensionStore = store.select(STORE_VAL.your_pension);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.cardRefreshStore = store.select(STORE_VAL.card_Refresh);
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.yourPensionStore.subscribe((val) => {
      if (val.length > 0) {
        this.pensionForm = val[0];
        // this.cameFromMicrosite = val[0].cameFromMicrosite;
        // this.pensionForm = this.formatNumbersToCurrencies(this.pensionForm);
        let form = {...this.pensionForm};
        this.pensionForm = this.formatNumbersToCurrencies(form);
      } else if (this.yourPensionForm && !this.quoteDatacaptureService.checkIfObjEmpty(val)) {
        this.yourPensionForm.reset();
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        this.quoteRefNo = val[0]?.quoteReferenceNumber;
        this.isValidated = val[0].isValidated;
        if (val[0] && val[0].editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          this.pensionFormEdit = JSON.parse(JSON.stringify(this.pensionForm));
          //console.log(this.pensionFormEdit);
        } else {
          this.editMode = false;
        }
      }
    });
    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.personalForm = val[0];
      }
    });

    this.cardRefreshStore.subscribe((val) => {
      if (val) {
        this.cardStoreVal = val[0]?.['setCardRefresh'];
        // console.log("card store", this.cardStoreVal);
      }
    });

    this.cardRefresh = this.quoteDatacaptureService.isCardCreatedforRefresh(this.quoteRefNo);

    //console.log("bottom pop up", this.selectedProductAvailable);
  }



  ngOnInit() {

    this.GetCMSDataService();
    // this.alertModalEditConfig.setContent(this.cmsAlertData.generalConstants.quoteChangeWarning);
    this.alertCardRefreshModalConfig.setContent(this.cmsAlertData.generalConstants.cardRefreshWarning);
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.userFormData();
    this.setConfigs();
    this.setSourcesConfiguration();
    this.setYourPensionForm();
    
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    if (this.pensionForm) {
      this.updateTotalFund('pageLoad');
      this.cameFromMicrosite = this.pensionForm.cameFromMicrosite;
      // this.ddlChange();
    }
    //  this.removeUnusedProductCodes((this.yourPensionForm).get('reAssure').value);
    // tslint:disable-next-line:max-line-length
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });
    // tslint:disable-next-line:prefer-const



  }



  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }

  setConfigs() {
    this.setSourceConfigData();
    this.setPensionFundConfigData();
  }

  setSourceConfigData() {
    let attributeObj = new AttributeIdAndStyle(ATTRIBUTE_NAME_ID.channelSection.source, '', null, null);
    let fundProvider = this.userForm.controls['fundProvider'] && this.userForm.controls['fundProvider'].value ? this.userForm.controls['fundProvider'].value : null;
    let sourceToFetch: DisplayRuleToBeApplied = new DisplayRuleToBeApplied(ATTRIBUTE_NAME_ID.channelSection.channel, 'DQE:D');
    let fundConfig = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.channelSection.source,
      this.annuitantCompRules);
    this.fundProviderConfig = this.uiRulesService.createMapperForDropdown(fundConfig, sourceToFetch, null,
      fundProvider);
    this.fundProviderConfig.errorMessage = this.userInputDetail.fundProviderConfig.errorMessage;
  }

  setPensionFundConfigData() {
    let attributeObj = new AttributeIdAndStyle(ATTRIBUTE_NAME_ID.channelSection.pensionFund, '', null, null);
    let fundConfig = this.uiRulesService.getUIRulesForgivenAttribute(ATTRIBUTE_NAME_ID.channelSection.pensionFund,
      this.annuitantCompRules);
    this.pensionFundConfig = {};
    this.pensionFundConfig['minValue'] = fundConfig.refList[0].minValue;
    this.pensionFundConfig['maxValue'] = fundConfig.refList[0].maxValue;
  }

  userFormData = () => {
    // this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.fundProviderChangeSub) {
      this.fundProviderChangeSub.unsubscribe();
    }
  }
  createQuestionarray(): any {
    const questionArray = [];
    if (this.yourPensionForm.controls.guarantees.value) {
      questionArray.push({
        questionCode: 'guaranteesQuestion',
        // question: this.contentData['guaranteesQuestion'].questionStatement,
        questionType: this.contentData['guaranteesQuestion'].questionType,
        answer: this.yourPensionForm.controls.guarantees.value
      });
    }
    if (this.yourPensionForm.controls.penalties.value) {
      questionArray.push({
        questionCode: 'penaltiesQuestion',
        // question: this.contentData['penaltiesQuestion'].questionStatement,
        questionType: this.contentData['penaltiesQuestion'].questionType,
        answer: this.yourPensionForm.controls.penalties.value
      });
    }
    return questionArray;
  }
  saveAfterLogin() {
    // tslint:disable-next-line: max-line-length
    const anlyticsNumOfValidation = Object.keys(this.yourPensionForm.controls).map(key => this.yourPensionForm.controls[key]).filter(v => v.status === 'INVALID').length;
    // tslint:disable-next-line: max-line-length
    // this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Login', dealPartner: this.yourPensionForm.get('fundProvider').value, totalFundAmount: this.totalFundAmount });
    let saveText = this.loginDetail.customer.registrationStatus ? 'Quote save - authenticated' : 'Quote save - non - authenticated';
    this.analyticsService.eventTrack({ type: 'Lightbox', name: saveText, position: this.getCurrentScreenURL() });
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveProgress() {
    // tslint:disable-next-line: max-line-length
    const anlyticsNumOfValidation = Object.keys(this.yourPensionForm.controls).map(key => this.yourPensionForm.controls[key]).filter(v => v.status === 'INVALID').length;
    // tslint:disable-next-line: max-line-length
    let saveText = this.loginDetail.customer.registrationStatus ? 'Quote save - authenticated' : 'Quote save - non - authenticated';
    this.analyticsService.eventTrack({ type: 'Lightbox', name: saveText, position: this.getCurrentScreenURL() });
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveAfterLogout() {
    // tslint:disable-next-line: max-line-length
    const anlyticsNumOfValidation = Object.keys(this.yourPensionForm.controls).map(key => this.yourPensionForm.controls[key]).filter(v => v.status === 'INVALID').length;
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Logout', dealPartner: this.yourPensionForm.get('fundProvider').value, totalFundAmount: this.totalFundAmount });

    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  saveFormValues() {
    this.sourcesCvt.forEach((item) => {
      this.yourPensionForm.value[item.controlName] = {...this.yourPensionForm.value[item.controlName],productCode:this.yourPensionForm.value[item.controlName].productCode.flat()};
    });
    this.removeUnusedProductCodes((this.yourPensionForm).get('reAssure').value);
    this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new YourPensionActions.AddYourPension({
      ...this.yourPensionForm.value, totalSum: this.totalFundAmount,
      cameFromMicrosite: this.cameFromMicrosite,
      cedingFund: this.cedingFundAmount, riskAndStaticQuestion: this.createQuestionarray(),
      productTypes: this.productTypesValues, productCodes: this.productCodeData, benefitTypes: this.benefitTypesValues,
      fundValidateInd: this.validateRules()
    }));

  }
  setYourPensionForm() {
    if (this.pensionForm) {
      this.lAndGWarningFlag = (this.pensionForm.fundProvider === 'I') ? true : false;
      this.aonWarningFlag = (this.pensionForm.fundProvider === 'M') ? true : false;
      this.slocWarningFlag = this.pensionForm.fundProvider === 'F' ? true : false;
      this.yourPensionForm = this.fb.group({
        guarantees: [this.pensionForm.guarantees, Validators.required],
        penalties: [this.pensionForm.penalties, Validators.required],
        manualSource: [this.pensionForm.manualSource],
        fundProvider: [this.pensionForm.fundProvider, Validators.required]
      });
    } else {
      this.yourPensionForm = this.fb.group({
        guarantees: [null, Validators.required],
        penalties: [null, Validators.required],
        manualSource: [null],
        fundProvider: [null, Validators.required],
      });
    }

    this.sourcesCvt.forEach((item) => {
      let tempFormGroup = this.fb.group({});
      this.fundAttributes.forEach(element => {

        if (element === 'productCode') {
          if (!this.pensionForm) {
            tempFormGroup.addControl(element, this.fb.array([this.fb.control('')],
              [ProductCodeValidators.productCodeValidator(item.productCodeValidationRule)]));
          }
          else {
            if (this.pensionForm[item.controlName].productCode.length > 0) {
              tempFormGroup.addControl(element, this.fb.array([...this.pensionForm[item.controlName].productCode],
                [ProductCodeValidators.productCodeValidator(item.productCodeValidationRule)]));
            } else {
              tempFormGroup.addControl(element, this.fb.array([this.fb.control('')],
                [ProductCodeValidators.productCodeValidator(item.productCodeValidationRule)]));
            }

          }

        } else if (element === 'transferType') {
          tempFormGroup.addControl(element, this.fb.control(item.code));
        } else {
          tempFormGroup.addControl(element, this.fb.control(null));
        }
      });
      if (this.pensionForm) {
        tempFormGroup.controls['fundValue'].setValue(this.pensionForm[item.controlName]?.fundValue);
        if (this.pensionForm[item.controlName].productCode.length > 0) {
          // tslint:disable-next-line: max-line-length
          tempFormGroup.controls['productCode'].setValue(this.pensionForm[item.controlName].productCode ? [...this.pensionForm[item.controlName].productCode] : ['']);
        }
        if (item.controlName === 'internal') {
          tempFormGroup.controls['transferType'].setValue('Int.');
        } else if (item.controlName == 'external') {
          tempFormGroup.controls['transferType'].setValue('Ext');
        } else {
          tempFormGroup.controls['transferType'].setValue('CDF');
        }
        // tempFormGroup.controls['transferType'].setValue(this.pensionForm[item.controlName].transferType);
      }
      this.yourPensionForm.addControl(item.controlName, tempFormGroup);
      //console.log(this.yourPensionForm);
    });
    // this.checkValidation();
    //console.log(this.yourPensionForm);
  }

  AddProductCode() {
    (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).push(this.fb.control('') as any);
  }
  RemoveProductCode(index: number) {
    (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).removeAt(index);
  }
  productCodeController(productCode: string) {
    (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).push(this.fb.control('') as any);
  }

  setSourcesConfiguration() {
    this.contentData['sourcesList'].forEach(source => {
      let item = {};
      item['config'] = source;
      item['controlName'] = this.getSourceControlName(source.sourceName);
      this.sourcesConfiguration.push(item);
    });
  }

  getSourceControlName(src: string): string {
    let srcControlName = '';
    srcControlName = this.sourcesCvt.filter(source => {
      return source['value'] === src;
    })[0]['controlName'];
    return srcControlName;
  }

  updateTotalFund(flag) {
    let totalFund = 0;
    let fundArray = [];
    this.sourcesCvt.forEach(element => {
      let fund = Object.assign({}, this.yourPensionForm.get(element.controlName).value);
      fund['fundValue'] = CurrencyFunctionalityService.convertCurrencyToNumber(fund['fundValue']);
      fundArray.push(fund);
    });
    const fundProvider = this.yourPensionForm.get('fundProvider').value;
    fundArray.forEach(element => {
      if (element['transferType'] === 'Ext' &&
        DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
        totalFund += 0;
      } else {
        totalFund += element['fundValue'];
      }
    });
    this.totalFundAmount = totalFund;
    this.cedingFundAmount = 0;
    // commenting thid method as part of DTC-591
    // this.checkMajorFundContributor(fundArray);

    this.validSource = false;
    this.sourcesConfiguration.forEach((sourceData) => {
      if (sourceData['config']['code'] === fundProvider) {
        sourceData['config']['enableFlag'] = true;
        this.validSource = true;
      } else {
        sourceData['config']['enableFlag'] = false;
      }
    });
    // tslint:disable-next-line: max-line-length
    if (fundProvider && !fundProvider.includes('I', 'B') && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
      const selectedFundProvider = this.sourcesCvt.find(s => s.fundProvider === fundProvider);
      const dealPartner = fundArray.filter(fund => {
        // tslint:disable-next-line: max-line-length
        return (selectedFundProvider && fund.transferType === selectedFundProvider.code && fund['fundValue'] > 0);
      });
      this.cedingFundAmount = (dealPartner && dealPartner.length > 0) ?
        dealPartner[0].fundValue : 0;
      // tslint:disable-next-line: max-line-length
    } else if (fundProvider && !fundProvider.includes('B') &&
      !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
      const LGFund = fundArray.filter(fund => {
        return (fund.transferType === 'Int.' && fund['fundValue'] > 0);
      });
      this.cedingFundAmount = (LGFund && LGFund.length > 0) ? LGFund[0].fundValue : 0;
    }
    if (this.validSource && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
      const external = this.sourcesConfiguration.find((sourceData) => {
        return sourceData.controlName === 'external';
      });
      external['config']['enableFlag'] = true;
    }
    //this.showNext(formChanged);
    this.validateRules(flag);
  }

  checkMajorFundContributor(fundArray) {

    const maxFund = Math.max.apply(Math, fundArray.map(function (fund) { return fund.fundValue; }));
    const maxFundSources = fundArray.filter(element => {
      return element.fundValue === maxFund;
    });
    if (maxFundSources.length > 1) {
      if (maxFundSources.filter(element => { return element.transferType === 'Int.' }).length <= 0) {
        this.manualSourceSelection = true;
        this.yourPensionForm.controls['manualSource'].setValidators(Validators.required);
        this.manualSourceConfig = Object.assign({}, this.contentData['manualSourceSelection']);
        this.manualSourceConfig.questionOptions = [];
        if (!(maxFundSources.length === 2 && maxFundSources.filter(element => { return element.transferType === 'Ext' }).length > 0)) {
          maxFundSources.forEach((element) => {
            if (element.transferType !== 'Ext') {
              let option = {};
              option['label'] = this.sourcesCvt.filter(temp => { return temp.code === element.transferType })[0].value;
              option['code'] = element.transferType;
              this.manualSourceConfig.questionOptions.push(option);
            }
          });
        } else {
          this.manualSourceSelection = false;
          this.yourPensionForm.controls['manualSource'].clearValidators();
        }
        //console.log(JSON.stringify(this.manualSourceConfig.questionOptions));
      } else {
        this.manualSourceSelection = false;
        this.yourPensionForm.controls['manualSource'].clearValidators();
      }
    } else {
      this.manualSourceSelection = false;
      this.yourPensionForm.controls['manualSource'].clearValidators();
    }
    this.yourPensionForm.controls['manualSource'].updateValueAndValidity();
  }

  validateProductCodeforReassure(): boolean {
    let rulesValid = true;
    if (this.yourPensionForm.controls['fundProvider'].value === 'J') {
      const pensionForm = this.yourPensionForm.controls['reAssure'];
      if (pensionForm['controls']['productCode'] && pensionForm['controls']['productCode'].value.join().replace(/,/g, '') === '') {
        this.minprodCodeLength.value = true;
        rulesValid = false
      }
      else {
        this.minprodCodeLength.value = false;
      }
    }
    return rulesValid;
  }

  validatePensionPot() {
    const fundProvider = this.yourPensionForm.controls['fundProvider'];
    const selectedProvider = this.sourcesCvt.forEach((source) => {
      const pensionForm = this.yourPensionForm.controls[source.controlName];
      if (pensionForm['controls'] && pensionForm['controls']['fundValue']) {
        const fundValue = pensionForm['controls']['fundValue'];
        const sourceCode = source.fundProvider === 'Int.' ? 'I' :
          (source.fundProvider === 'Ext' ? 'B' : source.fundProvider);
        if ((sourceCode === fundProvider.value) && (!fundValue.value ||
          (fundValue.value && parseFloat(fundValue.value) < 0.01))) {
          fundValue.setErrors({ emptyFund: true });
        } else {
          fundValue.setErrors(null);
        }
      }
    });
  }

  validateRules(flag?: string): boolean {
    let rulesValid = false;
    this.pensionPotErrorValidatorFlag = false;
    this.validatePensionPot();
    this.checkValidation();
    if (!this.yourPensionForm.valid && (flag && flag !== 'pageLoad')) {
      FormValidationsService.validateAllFormFields(this.yourPensionForm, this.analyticsService);
    }
    if (this.yourPensionForm.valid) {
      // rulesValid = (this.totalFundAmount && this.totalFundAmount >= 5000 && this.totalFundAmount < 1000000) ? true : false;
      // this.pensionPotErrorValidatorFlag = rulesValid ? false : true;
      rulesValid = true;
    }

    return rulesValid;
  }


  validateProductCode(productCodeData) {
    // let isValidProductCode = false;
    this.minprodCodeLength.value = false;
    if(productCodeData['event']!= '' && productCodeData['event'] != null && (productCodeData['event'] == 'sunLife' || productCodeData['event'] == 'aegon' || productCodeData['event'] == 'phoenixLife') ) {
      let getRegex = this.sourcesCvt.filter(element => {
        return element.controlName === productCodeData['event'];
      })[0].productCodeValidationRule;
      let productCodeValue = this.yourPensionForm.get(productCodeData['event']).get('productCode').value[0];
      let statusRegex =  (getRegex).test(productCodeValue);
      if(statusRegex == false) {
        this.yourPensionForm.get(productCodeData['event']).get('productCode').setErrors({invalidText: true});
     //   this.yourPensionForm.get(productCodeData['event']).get('productCode').status = 'INVALID';
      } else {
        this.yourPensionForm.get(productCodeData['event']).get('productCode').setErrors(null);
      //  this.yourPensionForm.get(productCodeData['event']).get('productCode').status = 'VALID';
      }
      
    }
    
  // //console.log(productCodeValue)
    const isValidProductCode = this.yourPensionForm.get(productCodeData['event']).get('productCode').valid;
    
    if (!isValidProductCode) {
      this.displayAlert = true;
      let formattedSourceName = this.sourcesCvt.filter(element => {
        return element.controlName === productCodeData['event'];
      })[0].value;
      this.alertModalConfig.setContent(this.contentData['sourcesList'].filter(source => {
        return source.sourceName === formattedSourceName;
      })[0].productCodeErrorMsg = productCodeData['event'] === 'sunLife' || productCodeData['event'] == 'phoenixLife' ? this.CMSData.stringGroup_GACodeErrorMessageWording
          : this.CMSData.stringGroup_ContractCodeErrorMessageWording);
    }
  }

  alertPrimaryBtnClick() {
    this.closeModal();
  }

  alertSecondaryBtnClick() {
    this.closeModal();
  }

  closeModal() {
    console.log("=============== coming in ==========")
    this.displayAlert = false;
    this.displayEditAlert = false;
    this.displayTooltipAlert = false;
  }
  gotoNext = () => {
    // tslint:disable-next-line: max-line-length
    const anlyticsNumOfValidation = Object.keys(this.yourPensionForm.controls).map(key => this.yourPensionForm.controls[key]).filter(v => v.status === 'INVALID').length;
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'Dropdown', name: '‘Pension provider', details: this.yourPensionForm.get('fundProvider').value, totalFundAmount: this.totalFundAmount, numOFValidationError: anlyticsNumOfValidation });
    let formchanged = false;
    this.resetErrorMessages();
    this.productCodeModel(this.yourPensionForm['value']['reAssure']);
    if (this.yourPensionForm['value']['external'].fundValue &&
      CurrencyFunctionalityService.convertCurrencyToNumber(this.yourPensionForm['value']['external'].fundValue) >= 0) {
      this.setExternalProductCode();
    }
    if (this.validateRules() && this.validateProductCodeforReassure()) {
      // tslint:disable-next-line:max-line-length
      const rulesValid = (this.totalFundAmount && this.totalFundAmount >= parseInt(this.contentData['minPensionValue'])
        && this.totalFundAmount < parseInt(this.contentData['maxPensionValue'])) ? true : false;
      if (rulesValid) {
        this.pensionPotErrorValidatorFlag = false;
        this.externalMinInvalid = false;
        if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
          this.referenceNumber = {...this.referenceNumber, editMode: false};
          this.referenceNumber = {...this.referenceNumber, isValidated: true};
          this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
          this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
          this.editMode = false;

          for (const val of this.sourcesCvt) {
            if (this.yourPensionForm.get(val.controlName).value.fundValue !== this.pensionForm[val.controlName].fundValue) {
              formchanged = true;
              break;
            }
            if (this.yourPensionForm.get(val.controlName).value.productCode !== this.pensionForm[val.controlName].productCode) {
              formchanged = true;
              break;
            }
          }
          if (!formchanged) {
            if (this.yourPensionForm.get('guarantees').value !== this.pensionForm['guarantees']) {
              formchanged = true;
            }
            if (this.yourPensionForm.get('penalties').value !== this.pensionForm['penalties']) {
              formchanged = true;
            }
          }
          if (formchanged) {
            this.saveFormValues();
            this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
              if (!this.cardStoreVal) {
                this.router.navigate(['/home/your-product-choice'], { replaceUrl: true });
              } else {
                this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
              }

            });
          } else {
            this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
          }
        } else {
          this.referenceNumber = {...this.referenceNumber,isValidated:true};
          this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
          this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
          this.saveFormValues();
          this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
            let count = 0;
            if (res['dealPartnerProductModel'] && res['dealPartnerProductModel']['productCodeModels']) {
              (res['dealPartnerProductModel']['productCodeModels']).forEach(element => {
                if (element['validProductCode'] == 'N') {
                  count++;
                }
              })
              if (count > 0) {
                this.displayAlert = true;
                this.alertModalConfig.setContent(this.contentData['sourcesList'].filter(source => {
                  return source.sourceName === 'ReAssure';
                })[0].productCodeErrorMsg = this.CMSData.stringGroup_ContractCodeErrorMessageWording);
                this.pensionForm =  {...this.pensionForm, productCodes : res['dealPartnerProductModel']['productCodeModels']};
                this.validateProductCodeResponse(res)
              } else {
                this.productCodeData = [];
                this.pensionForm = {...this.pensionForm, productCodes : res['dealPartnerProductModel']['productCodeModels']};
                this.router.navigate(['/home/your-product-choice']);

              }

            }
            if (res['dealPartnerProductModel'] && res['dealPartnerProductModel']['benefitTypes'] && res['dealPartnerProductModel']['benefitTypes'].length > 0) {
              this.pensionForm=  {...this.pensionForm, benefitTypes : res['dealPartnerProductModel']['benefitTypes']};
            }

            if (res['dealPartnerProductModel'] && res['dealPartnerProductModel']['productList'] && res['dealPartnerProductModel']['productList'].length > 0) {
              this.pensionForm['productTypes'] = res['dealPartnerProductModel']['productList'];
            }

          });
        }
      } else {
        if (this.yourPensionForm && this.yourPensionForm.get('fundProvider')
          && (this.yourPensionForm.get('fundProvider').value === 'B'
            || DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(this.yourPensionForm.get('fundProvider').value)) && this.totalFundAmount < 5000) {
          this.externalMinInvalid = true;
        } else {
          this.externalMinInvalid = false;
        }
        this.pensionPotErrorValidatorFlag = true;
        if (this.pensionPotErrorValidatorFlag && !this.externalMinInvalid) {
          this.analyticsService.eventTrack({ type: 'Lightbox', name: 'Unable to get a quote online', pageID: this.getCurrentScreenURL() });
        }
      }
    } else {
      FormValidationsService.validateAllFormFields(this.yourPensionForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  gotoNextPage() {
    if (this.validateRules()) {
      this.saveFormValues();
      this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {

        this.router.navigate(['/home/your-product-choice']);
      });
    }
  }
  OnBackClick() {
    // tslint:disable-next-line: max-line-length
    const anlyticsNumOfValidation = Object.keys(this.yourPensionForm.controls).map(key => this.yourPensionForm.controls[key]).filter(v => v.status === 'INVALID').length;
    // tslint:disable-next-line: max-line-length
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Back', dealPartner: this.yourPensionForm.get('fundProvider').value, totalFundAmount: this.totalFundAmount });
    this.saveFormValues();

  }

  formatNumbersToCurrencies(formData) {
    this.sourcesCvt.forEach((item) => {
    //   console.log('--2',item);
    //   if(item && item?.controlName){
    //     console.log('-3', formData);
    //   formData = {...formData, fundValue: CurrencyFunctionalityService.convertNumberToCurrency(formData[item.controlName].fundValue) }
    //     console.log('4', formData)
    // }
   
      let sourceData = formData[item.controlName];
      sourceData = {...sourceData, fundValue: CurrencyFunctionalityService.convertNumberToCurrency(sourceData.fundValue) }
     // sourceData['fundValue'] = CurrencyFunctionalityService.convertNumberToCurrency(sourceData['fundValue']);
     formData[item.controlName] = sourceData;
    });
    return formData;
  }

  showChangeAlert = () => {
    if (this.yourPensionForm.valid) {
      let formchanged = false;
      if (this.editMode) {
        //console.log(this.editMode)
        for (let val of this.sourcesCvt) {
          if (this.yourPensionForm.get(val.controlName).value.fundValue !== this.pensionFormEdit[val.controlName].fundValue) {
            //console.log(this.pensionFormEdit[val.controlName] + "popup");
            this.pensionFormEdit[val.controlName] = this.yourPensionForm.controls[val.controlName].value;
            formchanged = true;
            break;
          }
        }
        // formchanged=true;
        if (formchanged) {
          //console.log('yes');
          this.displayEditAlert = true;
        } else {
        }
      }
    }
  }
  txtChange = () => {
    this.showRefreshModal(false);
    this.showNext();
    this.validateRules();
    this.showChangeAlert();
    if (this.quoteDatacaptureService.responseQuoteCalculation && this.cardRefresh) {
      this.quoteDatacaptureService.postRefreshCard().subscribe();
    }
  }
  ddlChange = () => {
    this.sourceLength = 0;
    this.checkValidation();
    this.resetErrorMessages();


    const check = (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']);
    if (check.length > 0) {
      (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).reset();
    }

    let checksunLife = (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('sunLife')).controls['productCode']);
    if (checksunLife.length > 0) {
      let newState = JSON.parse(JSON.stringify(this.yourPensionForm.controls.sunLife.value));
      newState.productCode = [''];
      this.yourPensionForm.get('sunLife').setValue(newState);
      checksunLife.controls = [];
      checksunLife.setErrors(null);

    }
    let checkaegon = (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('aegon')).controls['productCode']);
    if (checkaegon.length > 0) {
      let newState = JSON.parse(JSON.stringify(this.yourPensionForm.controls.aegon.value));
      newState.productCode = [''];
      this.yourPensionForm.get('aegon').setValue(newState);
      checkaegon.controls = [];
      //checkaegon.controls[0].setValue("");
      checkaegon.setErrors(null);

    }
    let checkPhoenixLife = (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('phoenixLife')).controls['productCode']);
    if (checkPhoenixLife.length > 0) {
      let newState = JSON.parse(JSON.stringify(this.yourPensionForm.controls.phoenixLife.value));
      newState.productCode = [''];
      this.yourPensionForm.get('phoenixLife').setValue(newState);
      checkPhoenixLife.controls = [];
      checkPhoenixLife.setErrors(null);

    }
    if (this.yourPensionForm.controls['fundProvider'].valid) {
      const fundProvider = this.yourPensionForm.get('fundProvider').value;
      this.lAndGWarningFlag = (fundProvider === 'I') ? true : false;
      this.aonWarningFlag = (fundProvider === 'M') ? true : false;
      this.slocWarningFlag = (fundProvider === 'F') ? true : false;
      this.validSource = false;
      this.sourcesConfiguration.forEach((sourceData) => {
        if (sourceData['config']['code'] === fundProvider) {
          sourceData['config']['enableFlag'] = true;
          this.validSource = true;
        } else {
          sourceData['config']['enableFlag'] = false;
        }
      });
      if (this.validSource && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider)) {
        const external = this.sourcesConfiguration.find((sourceData) => {
          return sourceData.controlName === 'external';
        });
        external['config']['enableFlag'] = true;
      }
      this.clearMonetaryData(fundProvider);
    } else {
      this.lAndGWarningFlag = false;
      this.aonWarningFlag = false;
      this.slocWarningFlag = false;
      this.clearMonetaryData();
      this.validSource = false;
      this.sourcesConfiguration.forEach((sourceData) => {
        sourceData['config']['enableFlag'] = false;
      });
      FormValidationsService.validateFormField(this.yourPensionForm, 'fundProvider');
    }
    this.sourcesConfiguration.forEach((sourceData) => {
      if (sourceData['config']['enableFlag'] === true) {
        this.sourceLength = this.sourceLength + 1;
      }
    });



  }
  clearMonetaryData = (fundProvider?: string) => {
    this.totalFundAmount = 0;
    this.sourcesCvt.forEach((item) => {
      if (fundProvider === 'B' || (fundProvider !== 'B' && item.code !== 'B')) {
        // tslint:disable-next-line:prefer-const

        let tempFormGroup = this.fb.group({});
        this.fundAttributes.forEach(element => {
          if (element === 'productCode') {
            tempFormGroup.addControl(element, this.fb.array([this.fb.control('')],
              [ProductCodeValidators.productCodeValidator(item.productCodeValidationRule)]));
          } else if (element === 'transferType') {
            tempFormGroup.addControl(element, this.fb.control(item.code));
          } else {
            tempFormGroup.addControl(element, this.fb.control(null));
          }
        });
        tempFormGroup.controls['fundValue'].setValue([null]);
        tempFormGroup.controls['productCode'].setValue(['']);
        // tempFormGroup.controls['transferType'].setValue(null);
        if (item.controlName !== 'external') {
          this.totalFundAmount = 0;
          this.yourPensionForm.patchValue({
            [item.controlName]: {
              fundValue: null,
              // productCode: this.fb.array(['']),
              transferType: tempFormGroup.controls['transferType'].value
            }
          });
          this.yourPensionForm.setControl('productCode', this.fb.array(['']));
        } else {
          // tempFormGroup.controls['productCode'].setValue(['']);
          this.yourPensionForm.patchValue({
            [item.controlName]: {
              productCode: tempFormGroup.controls['productCode'].value,
            }
          });
          if (DealPartnerFunctionalityService.isDealPartnerWithoutExternalFund(fundProvider)) {
            this.totalFundAmount = 0;
            this.yourPensionForm.patchValue({
              [item.controlName]: {
                fundValue: null,
                transferType: tempFormGroup.controls['transferType'].value
              }
            });
          } else {
            this.resetExternalPot();
          }
        }
      } else if ('H,F,J,L,M,N,O,P,I'.includes(fundProvider)) {
        this.resetExternalPot();
      } else {
        this.totalFundAmount = 0;
      }
    });
  }
  checkValidation() {
    const fundProvider = this.yourPensionForm.controls['fundProvider'];
    const guarantees = this.yourPensionForm.controls['guarantees'];
    const penalties = this.yourPensionForm.controls['penalties'];
    // tslint:disable-next-line: max-line-length
    if (fundProvider) {
      if (fundProvider.value === 'K') {
        fundProvider.setErrors({ prudentialInvalid: true });
      } else if (fundProvider.value === 'D') {
        fundProvider.setErrors({ manyInvalid: true });
      } else if ((fundProvider.value === 'B' || DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider.value)) && this.personalForm &&
        this.personalForm.ukaddressIndicator === 'N') {
        fundProvider.setErrors({ externalInvalid: true });
      } else if (fundProvider.errors && !fundProvider.errors.required) {
        fundProvider.setErrors(null);
      }
      if (guarantees && guarantees.value) {
        if ((guarantees.value === 'Y' || guarantees.value === 'U') &&
          ((DealPartnerFunctionalityService.isDealPartner(fundProvider.value)
            && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider.value)
            && fundProvider.value !== 'K') ||
            fundProvider.value === 'I')) {
          guarantees.setErrors({ invalid: true });
        } else {
          guarantees.setErrors(null);
        }
      }
      if (penalties && penalties.value) {
        if ((penalties.value === 'Y' || penalties.value === 'U') &&
          ((DealPartnerFunctionalityService.isDealPartner(fundProvider.value)
            && !DealPartnerFunctionalityService.isDealPartnerWithoutProductCode(fundProvider.value)
            && fundProvider.value !== 'K') ||
            fundProvider.value === 'I')) {
          penalties.setErrors({ invalid: true });
        } else {
          penalties.setErrors(null);
        }
      }
      this.showControl = true;
      // this.validatePensionSource(fundProvider.value);
    }
  }
  toggleRiskQuestions = (control) => {
    this.checkValidation();
    if (this.yourPensionForm.controls[control].valid) {
    } else {
      FormValidationsService.validateFormField(this.yourPensionForm, control);
    }
    // if (this.yourPensionForm.controls['penalties'].valid) {
    // } else {
    //   FormValidationsService.validateFormField(this.yourPensionForm, 'penalties');
    // }
  }
  resetExternalPot = () => {
    const external = this.yourPensionForm.controls['external'];
    this.totalFundAmount = external['controls']['fundValue'].value ?
      CurrencyFunctionalityService.convertCurrencyToNumber(external['controls']['fundValue'].value) : 0;
    // tslint:disable-next-line:max-line-length
    external['controls']['fundValue'].value = this.totalFundAmount ? CurrencyFunctionalityService.convertNumberToCurrency(this.totalFundAmount) :
      external['controls']['fundValue'].value;
    external['controls']['fundValue'].setErrors(null);
  }
  ngAfterViewChecked() {
    this.checkValidation();
    this.cdRef.detectChanges();
  }
  ngAfterViewInit() {
    let formChanged;
    this.fundProviderChangeSub = this.yourPensionForm.get('fundProvider').valueChanges
      .pipe(
      filter(() => this.yourPensionForm.get('fundProvider').valid)
      )
      .subscribe(res => {
        if (this.pensionForm && res !== this.pensionForm.fundProvider) {
          this.fundProviderFlag = true;
          this.showRefreshModal(true);
          this.showNext(formChanged);

        }
      });

  }
  resetErrorMessages = () => {
    this.pensionPotErrorValidatorFlag = false;
    this.externalMinInvalid = false;
    this.minprodCodeLength.value = false;
  }

  productCodeModel(data) {
    //console.log(data);
    /** Web tracking here if unable to proceed online' based on fund value selection */
    //this.analyticsService.eventTrack({ type: 'Lightbox', name: 'Unable to get a quote online', pageID: this.getCurrentScreenURL() });
    /** Web tracking here if unable to proceed online' based on population of total pension pot */
    //this.analyticsService.eventTrack({type: '', name: 'Unable to get a quote online', pageID: this.getCurrentScreenURL()});

    this.productCodeData = [];
    if (data && data['productCode'] && data['productCode'].length > 0 &&
      data['productCode'].join() !== '') {
      data['productCode'].forEach(product => {
        this.productCodeData.push({
          productCode: product, productDescription: '', productGroup: '',
          validProductCode: '', amountType: null, matchSpecialInstruction: '',
          productCategory: '', specialInstruction: '', benefitsView: '',
          womEligibility: ''
        });
      });
    }
    //console.log(this.productCodeData)
  }

  validateProductCodeResponse = (res): boolean => {
    let isValid = true;
    const fundProvider = this.yourPensionForm.get('fundProvider');
    const fundControls = this.fundProviderConfig.options.filter(fund => fund.code === fundProvider.value);
    const fundControl = fundControls[0].controlName;
    const form = this.yourPensionForm.get(fundControl);
    const productCodeForm = form.get('productCode');
    const productCodeModel = res.dealPartnerProductModel.productCodeModels;

    productCodeForm['controls'].forEach((productForm) => {
      if (productForm.value) {

        const selectedProductArr = productCodeModel.filter(product => product.productCode === productForm.value);
        if (selectedProductArr && selectedProductArr.length > 0 && selectedProductArr[0].validProductCode === 'N') {
          productForm.setErrors({ notvalid: true });
          isValid = false;
        } else {
          productForm.setErrors(null);
        }
      }
    });
    return isValid;
  }

  removeUnusedProductCodes(data) {
    //console.log('enters here');
    //console.log(data['productCode']);
    if (data && data['productCode'] && data['productCode'].length > 0) {
      // length= data['productCode'].length;
      //let deletearray= (<FormArray>(<FormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).value.filter(f=> f ==='');

      (data['productCode']).forEach((elem, index) => {
        if (elem == '') {
          //(<FormArray>(<FormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).removeAt(index);
          (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).removeAt(
            (<UntypedFormArray><any>(<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']).value.findIndex(val => val === '')
          );
          // console.log((<UntypedFormGroup>this.yourPensionForm.get('reAssure')).controls['productCode']);

        }
      })
    }
  }

  closeCardRefreshModal() {
    this.resetForm();
    this.showNext(false);
  }

  alertPrimaryBtnClickinModal() {
    // this.quoteDatacaptureService.postRefreshCard().subscribe(res => {
    // });
    this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
    this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: false }));
    this.showModalForCardRefresh = false;
    const selectedProduct = this.quoteDatacaptureService.getSelectedProduct();
    if (selectedProduct && selectedProduct != null) {
      if (this.quoteDatacaptureService.getSelectedDealPartner() !== this.yourPensionForm.get('fundProvider').value) {
        this.selectedProductAvailable = false;
        this.resetStore();
      }
    }
    // tslint:disable-next-line: max-line-length
    if (this.totalFundAmount < 10000 && this.pensionForm && this.pensionForm.totalSum && this.pensionForm.totalSum >= 10000 && selectedProduct !== 'C') {
      this.selectedProductAvailable = false;
      this.resetStore();
    }

  }
  alertSecondaryCardRefreshBtnClick() {
    this.resetForm();
    this.selectedProductAvailable = true;
    this.showNext(false);
  }
  resetForm() {
    if (this.pensionForm) {
      this.yourPensionForm.get('fundProvider').setValue(this.pensionForm.fundProvider);
      const controlName = this.sourcesCvt.find(f => ((f.fundProvider === 'Int.') ? 'I' :
        (f.fundProvider === 'Ext') ? 'B' : f.fundProvider)
        === this.pensionForm.fundProvider).controlName;
      this.yourPensionForm.patchValue({
        [controlName]: {
          fundValue: this.pensionForm[controlName].fundValue,
        }
      });
      this.yourPensionForm.patchValue({
        ['external']: {
          fundValue: this.pensionForm['external'].fundValue,
        }
      });
      this.updateTotalFund('');

    }
    this.userInputDetail['buttonConfig']['label'] = 'Next';
    this.userInputDetail['buttonConfig']['name'] = 'Next';

    this.showModalForCardRefresh = false;
    this.selectedProductAvailable = true;
  }

  showRefreshModal(isDealPartnerChange) {
    const selectedProduct = this.quoteDatacaptureService.getSelectedProduct();
    if (this.cardRefresh && this.cardStoreVal && this.showModalForCardRefresh === false) {
      this.showModalForCardRefresh = true;
    } else {
      if (selectedProduct && selectedProduct != null) {
        if (this.quoteDatacaptureService.getSelectedDealPartner() !== this.yourPensionForm.get('fundProvider').value) {
          this.selectedProductAvailable = false;
          this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
          this.quoteDatacaptureService.requestQuoteCalculation = null;
          // this.store.dispatch(new ReqQuoteCalcActions.AddQuoteCalculation({}))
          this.store.dispatch(new ResQuoteCalcActions.RemoveQuoteCalculation(0));
          this.quoteDatacaptureService.responseQuoteCalculation = null;

          // this.store.dispatch(new ResQuoteCalcActions.AddQuoteCalculation({}))
          this.resetStore();
        } else {
          this.selectedProductAvailable = true;
        }
      }
      // tslint:disable-next-line: max-line-length
      if (this.totalFundAmount < 10000 && this.pensionForm && this.pensionForm.totalSum && this.pensionForm.totalSum >= 10000 && selectedProduct !== 'C') {
        this.selectedProductAvailable = false;
        this.resetStore();
      }
    }
  }

  resetStore() {
    this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    this.store.dispatch(new ResQuoteCalcActions.RemoveQuoteCalculation(0));
    this.quoteDatacaptureService.requestQuoteCalculation = null;
    this.quoteDatacaptureService.responseQuoteCalculation = null;
    //this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    // this.store.dispatch(new DepDetailsActions.RemoveDependantDetails(0));
    // this.store.dispatch(new ResQuoteCalcActions.AddQuoteCalculation({}));
  }
  showNext(formChanged = true) {
    if (this.referenceNumber && this.referenceNumber.editMode) {
      this.editMode = true;
      this.userInputDetail['buttonConfig']['label'] = formChanged === false ? 'Done' : 'Next';
      this.userInputDetail['buttonConfig']['name'] = formChanged === false ? 'Done' : 'Next';
    }

  }
  setExternalProductCode = () => {
    const fundProvider = this.yourPensionForm.get('fundProvider').value;
    const externalControl = this.yourPensionForm.get('external');
    switch (fundProvider) {
      case 'H':
        const aegonCode = this.yourPensionForm['value']['aegon']['productCode'];
        externalControl.get('productCode').setValue(aegonCode.join() ? aegonCode : ['00']);
        break;
      case 'F':
        const SLOCCode = this.yourPensionForm['value']['sunLife']['productCode'];
        externalControl.get('productCode').setValue(SLOCCode.join() ? SLOCCode : ['0']);
        break;
      case 'J':
        const reAssureCode = this.yourPensionForm['value']['reAssure']['productCode'];
        // externalControl.get('productCode').setValue(reAssureCode);
        this.yourPensionForm.patchValue({
          ['external']: {
            productCode: reAssureCode
          }
        });
        break;
      case 'O':
        const PHOCode = this.yourPensionForm['value']['phoenixLife']['productCode'];
        externalControl.get('productCode').setValue(PHOCode.join() ? PHOCode : ['0']);
        break;
    }
  }

  /** Code block for CMS */
  GetCMSDataService() {
    //console.log('original value = ', this.contentData.errorMessages.outOfFundErrorMessage);
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPensionSavings;
    this.utilService.getCMSData(URL)
      .subscribe(res => {
        //console.log('2 GetCMSDataService => ', res);
        this.CMSData = res;
        if (this.CMSData) {
          /** In the line below we are over-writing the contentData object values with CMSData object values */
          this.contentData.header = this.CMSData.string_YourPensionsSavingsTitle;
          this.contentData.introduction = this.CMSData.string_YourPensionsSavingsSubtitle;
          this.contentData.guaranteesQuestion.questionStatement = this.CMSData.string_PensionGuaranteesRiskQuestion;
          this.contentData.guaranteesQuestion.questionOptions.find(q => q['label'] === 'Yes').infoText
            = this.CMSData.string_PensionGuaranteesRiskQuestionYesWarningMessage;
          this.contentData.guaranteesQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText
            = this.CMSData.string_PensionGuaranteesRiskQuestionUnsureWarningMessage;
          this.contentData.invalidDealPartner = this.CMSData.stringGroup_RiskQuestionErrorMessageWording;
          this.contentData.penaltiesQuestion.questionStatement = this.CMSData.string_PensionPenaltiesRiskQuestion;
          this.contentData.penaltiesQuestion.questionOptions.find(q => q['label'] === 'Yes').infoText =
            this.CMSData.string_PensionPenaltiesRiskQuestionYesWarningMessage;
          this.contentData.penaltiesQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText =
            this.CMSData.string_PensionPenaltiesRiskQuestionUnsureWarningMessage;

          this.contentData.guaranteesQuestion.invalidDealPartner = this.CMSData.stringGroup_RiskQuestionErrorMessageWording;
          this.contentData.penaltiesQuestion.invalidDealPartner = this.CMSData.stringGroup_RiskQuestionErrorMessageWording;
          // this.contentData.pensionPotChoiceIntroStatement = this.CMSData.
          this.fundProviderConfig.label = this.CMSData.string_WhoReferredYouQuestionWording;
          this.funproviderinformationConfig.content = this.CMSData.string_WhoReferredYouInformationWording;
          // this.userInputDetail['buttonConfig'].label = this.CMSData.commonBlock.string_NextCTALabel;

          // replacing this 'Please enter an amount in one of the pension pot fields above' with 'Please enter an amount'
          this.contentData.errorMessages.noFundErrorMessage = this.CMSData.string_EnterAmountErrorMessageWording;
          this.contentData.errorMessages.outOfFundErrorMessage = this.CMSData.stringGroup_RiskQuestionErrorMessageWording;
          this.contentData.minFundErrorMessage = this.CMSData.string_ExternalLessThan5kErrorMessage + '.';
          // = this.CMSData.string_ContractCodeErrorMessageWordingTitle;
          this.contentData.sourcesList.find(q => q['sourceName'] === 'Aegon').infoIconData.content
            = this.CMSData.string_AegonContractCodeInformationWording;

          this.fundProviderConfig.prudentialInvalid = this.CMSData.string_PrudentialCannotQuoteOnlineErrorMessageWording;
          this.fundProviderConfig.manyInvalid = this.CMSData.stringGroup_MoreThanOneProviderErrorMessageWording;
          this.fundProviderConfig.externalInvalid = this.CMSData.string_NotUkAndExternalErrorMessageWording;
          // this.funproviderinformationConfig.content = this.CMSData.commonBlock.string_NoProviderSelectedErrorMessageWording;


          this.contentData.sourcesList.find(q => q['sourceName'] === 'ReAssure').infoIconData.content
            = this.CMSData.string_ReassureProductCodeInformationWording;

          this.contentData.sourcesList.find(source => source['sourceName'] === 'ReAssure').productCodeErrorMsg
            = this.CMSData.stringGroup_ContractCodeErrorMessageWording;

          this.contentData.sourcesList.find(source => source['sourceName'] === 'Sun Life Financial of Canada')
            .infoIconData.content = this.CMSData.string_SLOCGaCodeInformationWording;
          this.contentData.sourcesList.find(source => source['sourceName'] === 'Sun Life Financial of Canada')
            .productCodeErrorMsg = this.CMSData.stringGroup_GACodeErrorMessageWording;

          this.contentData.sourcesList.find(source => source['sourceName'] === 'Phoenix Life')
            .infoIconData.content = this.CMSData.string_SLOCGaCodeInformationWording.replace('Sun Life Financial of Cananda', 'Phoenix Life');
          this.contentData.sourcesList.find(source => source['sourceName'] === 'Phoenix Life')
            .productCodeErrorMsg = this.CMSData.stringGroup_GACodeErrorMessageWording;

          this.alertModalConfig = new AlertModal('alert', this.CMSData.string_ContractCodeErrorMessageWordingTitle, '', 'OK', '', '');

          this.contentDataConstants.quoteChangeWarning = this.CMSData.stringGroup_ContractCodeErrorMessageWording;
          this.alertModalEditConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');;
          this.contentData.pensionPotChoiceInfo.content = this.CMSData.string_PensionPotInformationWording;
          this.contentData.Aonreferralmessage = this.CMSData.string_AonReferralMessage;
          ////console.log('changed value = ', this.contentData.outOfFundErrorMessage);
        }
      });
  }

  /** End of code block for CMS */
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

  triggerWebAnalytics() {
    const fundProvider = this.yourPensionForm.controls['fundProvider'];
    const guarantees = this.yourPensionForm.controls['guarantees'];
    const penalties = this.yourPensionForm.controls['penalties'];

    if (guarantees) {
      if (guarantees.value === 'Y' || guarantees.value === 'U') {
        this.analyticsService.eventTrack({ type: 'Lightbox', name: 'Unable to get a quote online', pageID: this.getCurrentScreenURL() });
      }
    }
    if (penalties) {
      if (penalties.value === 'Y' || penalties.value === 'U') {
        this.analyticsService.eventTrack({ type: 'Lightbox', name: 'Unable to get a quote online', pageID: this.getCurrentScreenURL() });
      }
    }
  }

  totalPensionPotReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }
  productCodeReceiver(val) {
    this.analyticsService.eventTrack({ type: 'Question', name: val, pageID: this.getCurrentScreenURL() });
  }

  displayTooltipMessage(){
    this.tooltipModal.content = this.contentData.pensionPotChoiceInfo.content;
    this.displayTooltipAlert = true;
  }

  displayDrpTooltipMessage(){
    this.tooltipModal.content = this.funproviderinformationConfig.content;
    this.displayTooltipAlert = true;
  }

  displayTooltipMessageForContract(sourceConfig) {
    console.log(sourceConfig.infoIconData.content);
    this.tooltipModal.content = sourceConfig.infoIconData.content;
    this.displayTooltipAlert = true;
  }

}
